module.exports = __webpack_public_path__ + "img/amar_yes.aa3032cb.png";